import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [companyDropdownOpen, setCompanyDropdownOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = ['Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-line py-3' : 'bg-white border-b border-line py-4'}`} data-id="element-1167" data-mp="f02a7iwss4v9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1168" data-mp="ozt6nq4x4txz">
        <div className="flex justify-between items-center" data-id="element-1169" data-mp="dfz63log9bjp">
          {/* Logo Area */}
          <div className="flex items-center" data-id="element-1170" data-mp="hhaz816j8ewn">
            <a href="#home" className="flex items-center" aria-label="SyNeural home" data-id="element-1171" data-mp="hi2h6977ie4g">
              <img src="https://cdn.magicpatterns.com/uploads/pa3Fk96C6qU6AFqdF9EfnU/ChatGPT_Image_Aug_25,_2026,_10_57_05_AMff.png" alt="SyNeural — Creating an Intelligent Web" className={`w-auto transition-all duration-200 ${isScrolled ? 'h-8' : 'h-10'}`} data-id="element-1172" data-mp="mfcfyfghk24y" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-1173" data-mp="156ddr05vdrmx">
            <ul className="flex items-center gap-6" data-id="element-1174" data-mp="158yfzqa2y9l7">
              {/* Platform Dropdown */}
              <li className="relative" data-id="element-1175" data-mp="1a82p6gx087bj">
                <button onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-1176" data-mp="1f5l02cul0wm6">
                  Platform
                  <ChevronDown size={14} className={`transition-transform ${platformDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1177" data-mp="pi8hjollordc" />
                </button>

                <AnimatePresence data-id="element-1178" data-mp="zdinuoj17kwx">
                  {platformDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-1179" data-mp="1d5grijtz4olp">
                      <a href="#cji" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1180" data-mp="1po2mkuhm7obr">
                        <div className="font-semibold" data-id="element-1181" data-mp="1gncpzokj5twz">CJI</div>
                        <div className="text-xs text-ink-muted" data-id="element-1182" data-mp="1kprbkgfl37ry">
                          Civic Judgment Index
                        </div>
                      </a>
                      <a href="#ncji" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1183" data-mp="16sch2xah49t4">
                        <div className="font-semibold" data-id="element-1184" data-mp="3126cnpl30sbj">NCJI</div>
                        <div className="text-xs text-ink-muted" data-id="element-1185" data-mp="362arzca97h06">
                          Neurocognitive Index
                        </div>
                      </a>
                      <div className="border-t border-line my-2" data-id="element-1186" data-mp="1129jgbs64u42"></div>
                      <a href="#solutions" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1187" data-mp="10zx5satg15wt">
                        <div className="font-semibold" data-id="element-1188" data-mp="s3o04eevhb28">Solutions</div>
                        <div className="text-xs text-ink-muted" data-id="element-1189" data-mp="n3tf2rhs3fp3">
                          Applications & Use Cases
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {/* Company Dropdown */}
              <li className="relative" data-id="element-1190" data-mp="98qy99be85xi">
                <button onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-1191" data-mp="4ca8kaojpjib">
                  Company
                  <ChevronDown size={14} className={`transition-transform ${companyDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1192" data-mp="2fxsw9vqs6tbq" />
                </button>

                <AnimatePresence data-id="element-1193" data-mp="2oyh9wpc9iro3">
                  {companyDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-1194" data-mp="1saktbkgtrwcv">
                      <a href="#about" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1195" data-mp="2qlm3pt98mmxa">
                        <div className="font-semibold" data-id="element-1196" data-mp="1xxq7epnkyx11">About</div>
                        <div className="text-xs text-ink-muted" data-id="element-1197" data-mp="1sxkdt3xr30gb">
                          Mission & Vision
                        </div>
                      </a>
                      <a href="#research" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1198" data-mp="26yoclb9r9al7">
                        <div className="font-semibold" data-id="element-1199" data-mp="3ieldzyys5mzb">Research</div>
                        <div className="text-xs text-ink-muted" data-id="element-1200" data-mp="3ea58vzwzqjl5">
                          Future Work
                        </div>
                      </a>
                      <a href="#partnerships" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1201" data-mp="3qtixlfuo56yu">
                        <div className="font-semibold" data-id="element-1202" data-mp="3guth9rif7ukp">Partnerships</div>
                        <div className="text-xs text-ink-muted" data-id="element-1203" data-mp="3gx67eryc1b8u">
                          Collaborate with Us
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {navItems.map(item => <li key={item} data-id="element-1204" data-mp="3ote3id518o1">
                  <a href={`#${item.toLowerCase()}`} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors" data-id="element-1205" data-mp="3nrqkeexqtpf">
                    {item}
                  </a>
                </li>)}
            </ul>
            <div className="w-px h-5 bg-line" data-id="element-1206" data-mp="2s8ij2fi1ss6o"></div>
            <button className="bg-navy hover:bg-navy-light text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm" data-id="element-1207" data-mp="2sad4dux8emba">
              Request Demo
            </button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-ink-dark p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-1208" data-mp="2ehna737jub33">
            {mobileMenuOpen ? <X size={24} data-id="element-1209" data-mp="3759ob5eeky47" /> : <Menu size={24} data-id="element-1210" data-mp="376ugwph5q6zf" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-1211" data-mp="324vd5ehi981y">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-line overflow-hidden" data-id="element-1212" data-mp="2x7low25ur2fp">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-inner" data-id="element-1213" data-mp="1gncinvlhlbgm">
              {/* Platform submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-1214" data-mp="1lmph7dlq06z1">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-1215" data-mp="1ll4lvlrl0k04">
                  Platform
                </div>
                <a href="#cji" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1216" data-mp="1ufiython3ig2">
                  CJI
                </a>
                <a href="#ncji" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1217" data-mp="29bqkkmfp4rxg">
                  NCJI
                </a>
                <a href="#solutions" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1218" data-mp="2twwbkc5n96y7">
                  Solutions
                </a>
              </div>

              {/* Company submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-1219" data-mp="37y8pyj55p0hz">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-1220" data-mp="3cwaa77ebj5v1">
                  Company
                </div>
                <a href="#about" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1221" data-mp="3hsqvltu4v64f">
                  About
                </a>
                <a href="#research" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1222" data-mp="3vnt7cxlnvpp5">
                  Research
                </a>
                <a href="#partnerships" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1223" data-mp="9j7u7u37obnw">
                  Partnerships
                </a>
              </div>

              {navItems.map(item => <a key={item} href={`#${item.toLowerCase()}`} className="block px-3 py-3 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1224" data-mp="sasbw11t2zmj">
                  {item}
                </a>)}
              <div className="pt-4 px-3" data-id="element-1225" data-mp="1g2zaz7yx1kpn">
                <button className="w-full bg-navy text-white font-medium px-5 py-3 rounded-md shadow-sm" data-id="element-1226" data-mp="1b9mn50229hxy">
                  Request Demo
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}